import { turnWordIntoLink } from '../changeEditorLinkFns';

export const onBeforeInput = ({ chars, editorState, onChange }) => {
  if (chars === ' ') {
    return turnWordIntoLink({
      editorState,
      endChar: chars,
      onChange,
    });
  }
  return 'not-handled';
};
